var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.97 16.8008L18.49 11.6208C17.9647 11.2577 17.3501 11.0453 16.7127 11.0065C16.0754 10.9677 15.4395 11.104 14.8741 11.4006C14.3086 11.6972 13.8351 12.1429 13.5047 12.6894C13.1744 13.2358 12.9999 13.8622 13 14.5008L13 24.8608C12.9999 25.4993 13.1744 26.1258 13.5047 26.6722C13.8351 27.2187 14.3086 27.6644 14.8741 27.961C15.4395 28.2576 16.0754 28.3939 16.7127 28.3551C17.3501 28.3163 17.9647 28.1038 18.49 27.7408L25.97 22.5608C26.4362 22.2389 26.8172 21.8086 27.0804 21.307C27.3436 20.8053 27.4811 20.2473 27.4811 19.6808C27.4811 19.1143 27.3436 18.5562 27.0804 18.0546C26.8172 17.553 26.4362 17.1227 25.97 16.8008Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.c81005c5175354c7fd33ce4aeb6395d7.svg";
export { ForwardRef as ReactComponent };